export enum LoginMethod {
  PASSWORD = 'PASSWORD',
  SMS = 'SMS',
  DINGTALK = 'DINGTALK',
  WECOM = 'WECOM',
  FEISHU = 'FEISHU',
}
